/**
 * Render a timestamp as `YYYY-MM-DD HH:MM` in local time.
 *
 * Accepts both shapes the API returns: ISO instants, and D1's
 * `datetime('now')` output (`"YYYY-MM-DD HH:MM:SS"`), which has no zone marker
 * and would otherwise be read as local time rather than the UTC it is.
 * Unparseable input is passed through so a bad row shows its raw value instead
 * of "Invalid Date".
 */
export function formatTs(ts: string): string {
  const normalized = ts.includes("T") ? ts : `${ts.replace(" ", "T")}Z`;
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return ts;
  const date = d.toLocaleDateString("en-CA");
  const time = d.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return `${date} ${time}`;
}
